import React from 'react';
import { Button } from './ui/Button';
import { CheckIcon, ArrowRightIcon, MonitorIcon, CloudIcon, PlugIcon, SlidersIcon } from 'lucide-react';
const benefits = ['Готовый к работе интерфейс — запуск за дни, а не месяцы', 'REST API для интеграции с любыми внутренними системами', 'Панель управления без написания кода', 'Развёртывание в облаке или на ваших серверах (on-premise)', 'Гибкая настройка моделей под специфику ваших документов', 'Автоматическое масштабирование под любые объёмы'];
const highlights = [{
  icon: MonitorIcon,
  title: 'No-code панель',
  description: 'Управляйте обработкой документов через удобный веб-интерфейс без привлечения разработчиков.'
}, {
  icon: PlugIcon,
  title: 'API-first подход',
  description: 'Полноценный REST API с документацией и SDK для быстрой интеграции в ваши процессы.'
}, {
  icon: CloudIcon,
  title: 'Облако или on-premise',
  description: 'Выбирайте модель развёртывания: наше облако, ваш частный контур или гибридный вариант.'
}, {
  icon: SlidersIcon,
  title: 'Тонкая настройка',
  description: 'Адаптируйте модели распознавания под ваши типы документов без навыков машинного обучения.'
}];
export function Platform() {
  return <section className="py-24 bg-gray-900 border-t border-gray-800" data-id="element-218">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-219">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-220">
          <p className="text-sm font-semibold text-blue-400 uppercase tracking-wider mb-3" data-id="element-221">
            Платформа
          </p>
          <h2 className="text-3xl md:text-4xl font-sans font-bold text-white mb-6" data-id="element-222">
            Готовое решение — без разработки с&nbsp;нуля
          </h2>
          <p className="text-lg text-gray-400 leading-relaxed" data-id="element-223">
            Все возможности ScanMind доступны как единая платформа. Подключайте
            через API или используйте веб-интерфейс — никакой заказной
            разработки не требуется.
          </p>
        </div>

        {/* Highlight cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-16" data-id="element-224">
          {highlights.map((item, index) => <div key={index} className="bg-gray-800/60 border border-gray-700/50 rounded-xl p-6" data-id="element-225">
              <div className="w-10 h-10 bg-blue-900/40 rounded-lg flex items-center justify-center mb-4" data-id="element-226">
                <item.icon className="w-5 h-5 text-blue-400" data-id="element-227" />
              </div>
              <h3 className="text-base font-semibold text-white mb-2" data-id="element-228">
                {item.title}
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed" data-id="element-229">
                {item.description}
              </p>
            </div>)}
        </div>

        {/* Checklist + CTA */}
        <div className="bg-gray-800/40 border border-gray-700/50 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row gap-10 lg:gap-16 items-start lg:items-center" data-id="element-230">
          <div className="flex-1" data-id="element-231">
            <h3 className="text-xl font-semibold text-white mb-6" data-id="element-232">
              Что вы получаете из коробки
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3" data-id="element-233">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-234">
                  <div className="w-5 h-5 rounded-full bg-blue-900/50 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-235">
                    <CheckIcon className="w-3 h-3 text-blue-400" data-id="element-236" />
                  </div>
                  <span className="text-sm text-gray-300 leading-snug" data-id="element-237">
                    {benefit}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="flex flex-col items-start lg:items-center gap-4 flex-shrink-0" data-id="element-238">
            <Button variant="primary" size="lg" className="bg-white text-gray-900 hover:bg-gray-100 group" data-id="element-239">
              Запросить демо
              <ArrowRightIcon className="ml-2 w-4 h-4 group-hover:translate-x-0.5 transition-transform" data-id="element-240" />
            </Button>
            <span className="text-xs text-gray-500" data-id="element-241">
              Бесплатная консультация • 30 минут
            </span>
          </div>
        </div>
      </div>
    </section>;
}